import React, { HTMLProps } from 'react';

import { useTranslation } from 'next-i18next/pages';

import cn from 'classnames';

import { TranslationNamespace } from '@/i18n';

import cls from './StatisticTooltip.module.scss';

type StatisticTooltipProps = HTMLProps<HTMLDivElement> & {
	title: string;
	warehousesCount: number;
	workloadPercent: number;
};

export default function StatisticTooltip(props: StatisticTooltipProps) {
	const { className, title, warehousesCount, workloadPercent } = props;
	const { t } = useTranslation(TranslationNamespace.Marketing);

	return (
		<div className={cn(cls.container, className)} style={props.style}>
			<p className={cls.title}>{title}</p>
			<dl className={cls.list}>
				<div>
					<dt className={cls.value}>{warehousesCount}</dt>
					<dd className={cls.key}>{t('main-landing.warehouse-statistics.warehouses')}</dd>
				</div>
				<div>
					<dt className={cls.value}>{workloadPercent}%</dt>
					<dd className={cls.key}>{t('main-landing.warehouse-statistics.average-workload')}</dd>
				</div>
			</dl>
		</div>
	);
}
